import {FC} from "react"
import {ReactSVG} from "react-svg"

import {Button} from "@frontend/components/ui"
import check from "@frontend/design/icons/check.svg"
import linkIcon from "@frontend/design/icons/link.svg"
import {buildCaseShareUrl} from "@frontend/hostContract"
import {useTranslation} from "@frontend/i18n"
import {trackEvent} from "@frontend/utils/trackEvent"
import {useCopyText} from "@frontend/utils/useCopyText"
import {css} from "@styled-system/css"
import {hstack} from "@styled-system/patterns"

interface Props {
  caseId?: string
}

export const CopyLink: FC<Props> = ({caseId}) => {
  const t = useTranslation()

  const url = caseId ? buildCaseShareUrl(caseId) : window.location.href
  const [isCopied, clickCopy] = useCopyText(url)

  const onClickToCopy = (): void => {
    clickCopy()
    trackEvent("chat_save_case")
  }

  return (
    <div
      className={css({
        paddingX: 8,
        width: "100%",
        marginBottom: 4,
      })}
    >
      <div
        className={hstack({
          paddingBottom: 8,
          borderBottomWidth: 1,
          justifyContent: "flex-start",
          borderColor: "border.brand.primary",
          gap: 8,
          alignItems: "center",
        })}
      >
        <p
          className={css({
            textStyle: "bodyLight",
            color: "text.tertiary",
          })}
        >
          {t("conversation.caseLink.message")}
        </p>
        <Button
          variant="tertiaryBrand"
          size="small"
          onClick={onClickToCopy}
          leftElement={<ReactSVG src={isCopied ? check : linkIcon} />}
          title={isCopied ? t("case.copied") : t("case.copyLink")}
          css={css.raw({flexShrink: 0})}
        />
      </div>
    </div>
  )
}
